export enum WebVitals {
  Hydration = 'hydration',
  TTFB = 'TTFB',
  FCP = 'FCP',
  LCP = 'LCP',
  FID = 'FID',
  CLS = 'CLS',
  INP = 'INP',
}

export enum ClientMetricsActions {
  Show = 'shows',
  Click = 'clicks',
  Attempt = 'attempts',
  Success = 'successes',
  Failure = 'failures',
  Input = 'input',
  Submit = 'submit',
}

export enum GeneralClientMetrics {
  BoundaryError = 'boundaryError',
  Signin = 'signin',
  Signup = 'signup',
  Page = 'page',
  WebVitals = 'webVitals',
  Iframe = 'iframe',
  ToolApi = 'toolApi',
  ToolUser = 'toolUser',
}

export enum PremiumFeatureAwarenessMetricNames {
  GetPremiumButton = 'get_premium_button',
}

export enum ToolType {
  AiDetector = 'ai_detector',
  GrammarCheck = 'grammar_check',
  GoTemplates = 'go_templates',
  PlagiarismChecker = 'plagiarism_checker',
  InwellTextChecker = 'inkwell_text_checker',
}
